import { render, staticRenderFns } from "./activity-card.vue?vue&type=template&id=48c0e741&"
import script from "./activity-card.vue?vue&type=script&lang=js&"
export * from "./activity-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports